import { defineStore } from 'pinia'
import { LoadingBarState } from '~/types/app'
import { LOADING_BAR_DONE_DURATION_MS } from '~/constants/ui'

export const useAppStore = defineStore('app', () => {
  /**
   * Don't toggle loadingBarClass directly.
   * Use startLoad, endLoad functions instead to ensure proper animation.
   */
  const loadingBarClass = ref<LoadingBarState>(LoadingBarState.IDLE)
  const isBarLoading = computed(
    () => loadingBarClass.value === LoadingBarState.LOADING,
  )
  function startBarLoad() {
    loadingBarClass.value = LoadingBarState.LOADING
  }
  function endBarLoad() {
    loadingBarClass.value = LoadingBarState.DONE
    setTimeout(() => {
      if (loadingBarClass.value === LoadingBarState.DONE)
        loadingBarClass.value = LoadingBarState.IDLE
    }, LOADING_BAR_DONE_DURATION_MS)
  }

  return {
    startBarLoad,
    endBarLoad,
    loadingBarClass,
    isBarLoading,
  }
})
